<ng-container *mobxAutorun>
  <div class="validation-panel-container" *ngIf="isVisible">
    <div class="card border-{{ panelType }}">
      <div
        class="card-header bg-{{ panelType }} text-white d-inline-flex
               justify-content-between"
      >
        <span class="header-title">{{ currentLabel }}</span>
        <div class="actions-bar d-inline-flex justify-content-between">
          <button
            lf-button
            class="panel-focus"
            size="sm"
            [title]="focusButtonTooltip"
            [attr.aria-label]="focusButtonTooltip"
            [style]="'outline-light'"
            (click)="triggerFocus()"
            [isDisabled]="shouldDisableFocusButton"
          >
            <lf-icon icon="crosshairs"></lf-icon>
          </button>
          <div class="panel-pages-number ml-4" *ngIf="!hasNoIssues">
            {{ currentPathIndex + 1 }}/{{ nPages }}
          </div>
          <div class="btn-group mr-4 ml-2">
            <button
              lf-button
              class="panel-prev"
              size="sm"
              [title]="prevButtonTooltip"
              [attr.aria-label]="prevButtonTooltip"
              [style]="'outline-light'"
              [isDisabled]="!hasPrevious"
              (click)="previous()"
            >
              <lf-icon icon="chevron-left"></lf-icon>
            </button>
            <button
              lf-button
              class="panel-next"
              size="sm"
              [title]="nextButtonTooltip"
              [attr.aria-label]="nextButtonTooltip"
              [style]="'outline-light'"
              [isDisabled]="!hasNext"
              (click)="next()"
            >
              <lf-icon icon="chevron-right"></lf-icon>
            </button>
          </div>
          <button
            lf-button
            class="panel-close"
            size="sm"
            [title]="closeButtonTooltip"
            [attr.aria-label]="closeButtonTooltip"
            [style]="'outline-light'"
            (click)="hide()"
          >
            <lf-icon icon="times"></lf-icon>
          </button>
        </div>
      </div>
      <div class="card-body bg-{{ panelType }}">
        <div *ngIf="isPending" class="pending"></div>
        <ng-container *ngIf="!isPending && errors.length > 0">
          <strong>
            <lf-icon icon="exclamation-circle"></lf-icon>
            {{ errorsText }}
          </strong>
          <ul>
            <li
              *ngFor="let error of errors"
              class="validation-issue"
              lfValidationIssue
              [path]="currentPath"
              [issue]="error"
            ></li>
          </ul>
        </ng-container>
        <ng-container *ngIf="!isPending && warnings.length > 0">
          <strong>
            <lf-icon icon="exclamation-triangle"></lf-icon>
            {{ warningsText }}
          </strong>
          <ul>
            <li
              *ngFor="let warning of warnings"
              class="validation-issue"
              lfValidationIssue
              [path]="currentPath"
              [issue]="warning"
            ></li>
          </ul>
        </ng-container>
        <ng-container *ngIf="!isPending && hasNoIssues">
          {{ noIssuesText }}
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
